import { render, staticRenderFns } from "./ResearchParameters.vue?vue&type=template&id=555d5ec2&scoped=true&"
import script from "./ResearchParameters.vue?vue&type=script&lang=js&"
export * from "./ResearchParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d5ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555d5ec2')) {
      api.createRecord('555d5ec2', component.options)
    } else {
      api.reload('555d5ec2', component.options)
    }
    module.hot.accept("./ResearchParameters.vue?vue&type=template&id=555d5ec2&scoped=true&", function () {
      api.rerender('555d5ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/landing-page/components/research/ResearchParameters.vue"
export default component.exports